
import React, { useState } from 'react';
import './styleUpdatingTerritory.css';
import ModalvVewingHouse from './ModalvVewingHouse';
import ModalUpdatingHouse from './ModalUpdatingHouse';
import { SearchAreaAddress } from '../Optics/LoadingData/LoadingDataTerritory';
import ModalAddHouse from '../Administration/ModalAddHouse';
import ModalDeleteHouse from '../Administration/ModalDeleteHouse';
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_MASTER, ROLE_SENIOR_MASTER } from '../Optics/Constants/ConstantsOptics';
import CustomSnackbar from '../Optics/Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {Button} from '@mui/material';


const UpdatingTerritory = (role) => {
    const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

    const [area, setArea] = useState('');
    const [addresses, setAddresses] = useState([]);
    const [error, setError] = useState('');
    const [selectedStreet, setSelectedStreet] = useState(null); 
    const [selectedHouseNumber, setSelectedHouseNumber] = useState(null); 
    const [selectedEntrances, setSelectedEntrances] = useState(null); 
    const [selectedHouseId, setSelectedHouseId] = useState(null); 
    const [openVewingModal,  setOpenVewingModal] = useState(false); 
    const [openUpdatingModal,  setOpenUpdatingModal] = useState(false); 
    const [selectedCoordinates, setSelectedCoordinates] = useState([]); 
    const [openModalAddHouse, setOpenModalAddHouse] = useState(false);
    const [openModalDeleteHouse, setOpenModalDeleteHouse] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [onlyResidential, setOnlyResidential] = useState(false);
    const [onlySchool, setOnlySchool] = useState(false);
    const [onlyShoppingCenters, setOnlyShoppingCenters] = useState(false);
    const [onlyPrivateSector, setOnlyPrivateSector] = useState(false);
    const [onlyHostel, setOnlyHostel] = useState(false);
    const [onlyOffice, setOnlyOffice] = useState(false);

    


    const normalizeString = (str) =>
      str.toLowerCase()
          .replace(/[^\w\sа-яёіїє]/gi, '')  // Убираем знаки препинания
          .replace(/\s+/g, ' ')             // Убираем лишние пробелы
          .trim();
  
    // const filteredAddresses = addresses.filter(address => {
    //     const street = normalizeString(address.street);
    //     const houseNumber = String(address.houseNumber).trim();
    
    //     const query = normalizeString(searchQuery);
    //     const queryParts = query.split(" ");
    
    //     if (queryParts.length === 1) {
    //         // Если введено одно слово – ищем по улице
    //         return street.includes(query);
    //     } else {
    //         // Если введены 2+ слова – последнее считаем номером дома
    //         const streetQuery = queryParts.slice(0, -1).join(" ");
    //         const houseQuery = queryParts[queryParts.length - 1];
    
    //         return street.includes(streetQuery) && houseNumber === houseQuery;
    //     }
    // });
    const filteredAddresses = addresses.filter(address => {
    if (onlyResidential && address.typeName !== "Жилой многоэтажный дом") {
        return false;
    }
    if (onlySchool && address.typeName !== "Школы") {
        return false;
    }
     if (onlyShoppingCenters && address.typeName !== "Торговые центры") {
        return false;
    }
     if (onlyPrivateSector && address.typeName !== "Частный сектор") {
        return false;
    }
    if (onlyHostel && (address.typeName !== "Коммунальные общежития" || address.typeName !== "Студенческие общежития")) {
        return false;
    }
    if (onlyOffice && address.typeName !== "Офисные здания") {
        return false;
    }

    const street = normalizeString(address.street);
    const houseNumber = String(address.houseNumber).trim();
    const query = normalizeString(searchQuery);
    const queryParts = query.split(" ");

    if (queryParts.length === 1) {
        return street.includes(query);
    } else {
        const streetQuery = queryParts.slice(0, -1).join(" ");
        const houseQuery = queryParts[queryParts.length - 1];
        return street.includes(streetQuery) && houseNumber === houseQuery;
    }
});


    const searchAddress = async () => {
        SearchAreaAddress(area, setAddresses, setError);
        setSearchQuery('');
    };

    const handleRowClick = (id,street, houseNumber, entrances, coordinates, status) => {
      setSelectedStreet(street);
      setSelectedHouseNumber(houseNumber);
      setSelectedEntrances(entrances); 
      setSelectedCoordinates(coordinates);
      if(status){
        setOpenVewingModal(true);
         setSelectedHouseId(id);
      }else{
        setOpenUpdatingModal(true);
        setSelectedHouseId(id);
      }
      
    };

    const openModalAddHouses = () => {
        setOpenModalAddHouse(true);
      }; 

      const openModalDeleteHouses = () => {
        setOpenModalDeleteHouse(true);
      }; 

      const copyToClipboard = (text) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        textarea.focus(); 
        try {
          const successful = document.execCommand("copy");
          if (successful) {
            showSnackbar('Скопировано: ID: ' + text, 'snackbarOk');
          } else {
            showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
          }
        } catch (err) {
          showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
        }
        document.body.removeChild(textarea);
      };
     

    const totalAddresses = filteredAddresses.length;
    const totalActualized = filteredAddresses.filter(address => address.status).length;
    const totalNoCoordinates = totalAddresses - totalActualized;

    return (
      <div className="updating-territory">
      <label style={{color: "#a1a1a1", fontSize: "18px"}}>Актуализация территории</label>
      <div className="flex-container" >
          <div>
              <input
                  className='inputAuth'
                  type="number"
                  placeholder="ветка"
                  value={area}
                  style={{width: '150px', padding:'5px'}}
                  onChange={(e) => setArea(e.target.value)}
              />
              <button className='buttonLogin' onClick={searchAddress} style={{padding: '5px'}}>Поиск</button>
              
          </div>
          <div className="address-summary" style={{padding: '10px'}}>
            <label style={{color: "#c5c5c5"}}>Всего адресов: <span style={{color: "orange"}}>{totalAddresses}.</span></label>
            <label style={{color: "#c5c5c5", marginLeft: "10px"}}>Актуализировано: <span style={{color: "#71fc64"}}>{totalActualized}.</span></label>
            <label style={{color: "#c5c5c5", marginLeft: "10px"}}>Нет координат: <span style={{color: "#fc7664"}}>{totalNoCoordinates}.</span></label>
          </div>
          <button className='buttonIsModal' style={{borderRadius:'10px', color: '#333333'}} onClick={openModalAddHouses}>Внести дом вручную</button>

          {(role.role === ROLE_ADMIN || role.role === ROLE_ENGINNER || role.role === ROLE_MASTER || role.role === ROLE_SENIOR_MASTER) && (
             <button className='buttonIsDeleteModal2' style={{color: '#333333', background: "#fc7664"}} onClick={openModalDeleteHouses}>Удалить координаты дома</button>
          )}
         
      </div>
      <hr className='horizontalLine12Modal'/>

            {error && <p style={{ color: 'red' }}>{error}</p>}

            <input 
                type="text" 
                placeholder="поиск по таблице" 
                value={searchQuery} 
                className='textInputPoiskModal'
                onChange={(e) => setSearchQuery(e.target.value)} 
                style={{ width: '200px' }}
                />

                <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyResidential}
                    onChange={(e) => {
                        setOnlyResidential(e.target.checked);
                        if (e.target.checked) {
                            setOnlySchool(false);
                            setOnlyShoppingCenters(false);
                            setOnlyPrivateSector(false);
                            setOnlyHostel(false);
                            setOnlyOffice(false);
                        }
                    }}
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                />
                многоэтажки
                </label>

                 <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlySchool}
                     onChange={(e) => {
                        setOnlySchool(e.target.checked);
                        if (e.target.checked) {
                            setOnlyResidential(false);
                            setOnlyShoppingCenters(false);
                            setOnlyPrivateSector(false);
                            setOnlyHostel(false);
                            setOnlyOffice(false);
                        }
                    }}
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                />
                школа
                </label>

                 <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyShoppingCenters}
                     onChange={(e) => {
                        setOnlyShoppingCenters(e.target.checked);
                        if (e.target.checked) {
                            setOnlyResidential(false);
                            setOnlySchool(false);
                            setOnlyPrivateSector(false);
                            setOnlyHostel(false);
                            setOnlyOffice(false);
                        }
                    }}
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                />
                ТЦ
                </label>

                 <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyPrivateSector}
                     onChange={(e) => {
                        setOnlyPrivateSector(e.target.checked);
                        if (e.target.checked) {
                            setOnlyResidential(false);
                            setOnlySchool(false);
                            setOnlyShoppingCenters(false);
                            setOnlyHostel(false);
                            setOnlyOffice(false);
                        }
                    }}
                    style={{ marginRight: '5px',  verticalAlign: 'middle' }}
                />
                ЧС
                </label>

                 <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyHostel}
                     onChange={(e) => {
                        setOnlyHostel(e.target.checked);
                        if (e.target.checked) {
                            setOnlyResidential(false);
                            setOnlySchool(false);
                            setOnlyShoppingCenters(false);
                            setOnlyPrivateSector(false);
                            setOnlyOffice(false);
                        }
                    }}
                    style={{ marginRight: '5px',  verticalAlign: 'middle' }}
                />
                общежития
                </label>

                <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                                <input
                                    type="checkbox"
                                    checked={onlyOffice}
                                    onChange={(e) => {
                                        setOnlyOffice(e.target.checked);
                                        if (e.target.checked) {
                                            setOnlyResidential(false);
                                            setOnlySchool(false);
                                            setOnlyShoppingCenters(false);
                                            setOnlyPrivateSector(false);
                                            setOnlyHostel(false);
                                        }
                                    }}
                                    style={{ marginRight: '5px',  verticalAlign: 'middle' }}
                                />
                                офис
                                </label>
                


            {filteredAddresses.length > 0 && (
              


            <div className="table-container">
                <table className="address-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Город</th>
                            <th>Округ</th>
                            <th>Регион</th>
                            <th>Ветка</th>
                            <th>Улица</th>
                            <th>Номер дома</th>
                            <th>Подъездов</th>
                            <th>Тип</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredAddresses.map((address, index) => (
                            <tr 
                                key={index} 
                                className={address.status ? 'status-actualized' : 'status-no-coordinates'}
                                onClick={() => handleRowClick(address.id, address.street, address.houseNumber, address.entrances, address.coordinates, address.status)}
                            >
                                <td>
                                    {address.id}
                                    <Button 
                                        style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                                        onClick={(e) => {
                                            e.stopPropagation(); 
                                            copyToClipboard(address.id);
                                        }}
                                    >
                                        <FileCopyIcon style={{ color: '#e0920b' }} />
                                    </Button>           
                                </td>
                                <td>{address.city}</td>
                                <td>{address.canton}</td>
                                <td>{address.region}</td>
                                <td>{address.area}</td>
                                <td>{address.street}</td>
                                <td>{address.houseNumber}</td>
                                <td>{address.entrances}</td>
                                <td>
                                {address.typeName.length > 10
                                    ? address.typeName.slice(0, 10) + '...'
                                    : address.typeName}
                                </td>
                                <td>
                                    <img src={address.status ? './ok.png' : './no.png'} alt="status icon"/>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
           
        )}

            {/* {addresses.length > 0 && (
                
                <div className="table-container">
                    <table className="address-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Город</th>
                                <th>Округ</th>
                                <th>Регион</th>
                                <th>Ветка</th>
                                <th>Улица</th>
                                <th>Номер дома</th>
                                <th>Подъездов</th>
                                <th>Статус</th>
                            </tr>
                        </thead>
                        <tbody>
                            {addresses.map((address, index) => (
                               
                                <tr 
                                
                                    key={index} 
                                    className={address.status ? 'status-actualized' : 'status-no-coordinates'}
                                    onClick={() => handleRowClick(address.id, address.street, address.houseNumber, address.entrances, address.coordinates, address.status)}
                                >
                                    <td>{address.id}
                                    <Button 
                                        style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                                        onClick={(e) => {
                                            e.stopPropagation(); 
                                            copyToClipboard(address.id);
                                        }}
                                    >
                                        <FileCopyIcon style={{ color: '#e0920b' }} />
                                    </Button>           
                                    </td>
                                   
                                    <td>{address.city}</td>
                                    <td>{address.canton}</td>
                                    <td>{address.region}</td>
                                    <td>{address.area}</td>
                                    <td>{address.street}</td>
                                    <td>{address.houseNumber}</td>
                                    <td>{address.entrances}</td>
                                    <td >
                                        <img src={address.status ? './ok.png' : './no.png'} alt="status icon"/>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )} */}

           {/* {openModal && ( */}
                <ModalvVewingHouse
                    open={openVewingModal}
                    onClose={() => setOpenVewingModal(false)}
                    street={selectedStreet} 
                    houseNumber={selectedHouseNumber}
                    entrances={selectedEntrances}
                    hid={selectedHouseId}
                    coordinates={selectedCoordinates}
                    searchAddress={searchAddress}
                />
                
                <ModalUpdatingHouse
                    open={openUpdatingModal}
                    onClose={() => setOpenUpdatingModal(false)}
                    houseId={selectedHouseId}
                    street={selectedStreet} 
                    houseNumber={selectedHouseNumber}
                    entrances={selectedEntrances}
                    coordinates={selectedCoordinates}
                    searchAddress={searchAddress}
                />

                 {/* Добавить дом вручную*/}
                 <ModalAddHouse
                    open={openModalAddHouse}
                    onClose={() => setOpenModalAddHouse(false)} 
                    searchAddress={searchAddress}
                />

                  {/* Удалить дом*/}
              
                  <ModalDeleteHouse
                    open={openModalDeleteHouse}
                    onClose={() => setOpenModalDeleteHouse(false)} 
                    searchAddress={searchAddress}
                />
                  {/* Snackbar */}
                    <Snackbar
                         anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'left',
                         }}
                         open={snackbarOpen}
                         autoHideDuration={3000}
                         onClose={handleCloseSnackbar}
                         message={snackbarMessage}
                         ContentProps={{
                          style: {
                            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                          }
                        }}
                      />
             
               
        </div>
    );
};

export default UpdatingTerritory;